/************************************************************
 Episode Namespace
 ************************************************************/

window.episode = {
    _action:null,
    _callback:null,
    _row:null,
    _wf_action_params:null,
    // Execute Action
    executeAction:function (action, row, callback) {
        var wfId = parseInt(action.wf_id),
            actionId = parseInt(action.wf_action_id);

        this._action = action;
        this._callback = callback;
        this._row = row;
        this._wf_action_params = ((action.wf_action_params != null) && (action.wf_action_params != "")) ? $.parseJSON(action.wf_action_params) : null ;

        if (wfId == 48 && (actionId == 107 || actionId == 3)) { //
            debug.log('episode.openReason ; 1');
            episode.openReason(episode._callback);
        }
        // Cancel or absence
        else if (actionId == 3 || actionId == 15 || actionId == 74) {
            debug.log('appointmentNS.executeAction ; 2', this._action, this._row, this._callback);
            appointmentNS.executeAction(this._action, this._row, this._callback);
        }
        // Reschedule
        else if ((wfId == 1 || wfId == 2 || wfId == 38) && actionId == 2) {
            debug.log("episode.openScheduler ; 3");
            episode.openScheduler();
        }
        // Undo Patient Arrival
        else if (actionId == 17) {
            debug.log('episode.openReason ; 4');
            episode.openReason(episode.undoPatientArrivalReasonModalHandler);
        } else if (wfId == 2 && actionId == 16) {
            debug.log('physiotherapy.executeAction ; 5');
            physiotherapy.executeAction(episode._action, episode._row, episode._callback);
        }
        // Print Marking Consult
        else if(actionId == 23  && wfId == 1){
            debug.log('Print Marking Consult ; 6');

            var url = "/appointments/marking_consult_sheet?patient_id="+row.patient_id+"&task_id="+action.task_id;

            Hades.showDocument(url);
            episode._callback(true, episode._action, episode._row);
        }
        // Print Marking Consult Change
        else if(actionId == 24  && wfId == 1){
            debug.log('Print Marking Consult Change ; 7');

            var url = "/appointments/marking_consult_change_sheet?patient_id="+row.patient_id+"&task_id="+action.task_id;

            Hades.showDocument(url);
            episode._callback(true, episode._action, episode._row);
        }
        //Undo Start Episode
        else if (actionId == 99) {
            debug.log('episode.openReason ; 8');
            episode.openReason(episode.undoStartEpisode)
        // }
        // //Undo Finalize Episode
        // else if ( actionId == 100 && ( wfId == 2 ) &&  (parseInt(this._row.appointment_type_id) == globalConstants.APPOINTMENT_TYPE_EXAM && parseInt(this._row.treatment_type_id) == globalConstants.TREATMENT_TYPE_MCDT)) {
        //     debug.log('episode.checkCanUndoFinalizeEpisode ; 9');
        //     episode.checkCanUndoFinalizeEpisode();

        } else if ( actionId == 100 && ( wfId == 2 || wfId == 44  || wfId == 38 || wfId == 15 || wfId == 8 ) ) {
            debug.log('episode.undoFinalizeEpisodeHandler ; 10');
            episode.undoFinalizeEpisodeHandler();

        } else if ( (actionId == 109 || actionId == 110) && (wfId == 2 || wfId == 38 || wfId == 44) ) {
            debug.log('episode.openReason ; 11');
            episode.openReason(episode.administrativeActions)
        }
        else if (wfId == 38 && ( actionId == 4 || actionId == 76 || actionId == 77 || actionId == 5 || actionId == 10 || actionId == 11 || actionId == 1) ) {
            this._action.from_state_id == this._action.wf_status_id;
            debug.log('workflow.executeGenericAction ; 12');
            workflow.executeGenericAction(this._action, this._callback, this._row);
        }
        else if (wfId == 44 && actionId == 5){

            if (this._wf_action_params != null && this._wf_action_params[0].action_type == globalConstants.WF_ACTION_TYPE_LOAD_MODAL){
                debug.log('workflowService.executeServiceFactory ; 13');
                workflowService.executeServiceFactory(this._action)
                //episode.openFinalizedSmapConsult(this._action, this._wf_action_params);
            }
            else{
                debug.log('workflow.executeGenericAction ; 14');
                workflow.executeGenericAction(this._action, this._callback, this._row);
            }
        }

        // Other actions}
        else {

            episode.executeGenericAction();
            // Validate Auto Billing (Create invoice for non presential consultations)
            billingModel.validateAutoBilling({wf_status_id: episode._action.to_state_id, episode_id: episode._action.task_id});
        }

    },
    openReason:function (callback) {
        var params = {
            task_id:episode._action.task_id,
            wf_id:episode._action.wf_id,
            wf_status_id:episode._action.to_state_id,
            wf_from_state_id:episode._action.from_state_id,
            wf_action_id:episode._action.wf_action_id,
            actionId: episode._action.wf_action_id
        };

        $.get('/modal/generic_reason_window', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                $('#generic-reason-modal-ct').bind('genericReasonConfirmed', callback);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                episode._callback(false, episode._action, episode._row);
            });
    },
    undoPatientArrivalReasonModalHandler:function (event, data) {
        $.fancybox.close(true);

        var params = {
            task_id:episode._row.task_id,
            reason_id:data.reasonId,
            other_reason:data.otherReason,
            date:data.date,
            hour:data.hour,
            wf_id:episode._row.wf_id,
            wf_status_id:episode._row.wf_status_id,
            wf_action_id:data.actionId};

        $.post('/episode/undo_patient_arrival', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    episode._callback(false, episode._action, episode._row);
                } else {
                    episode._callback(true, episode._action, episode._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                episode._callback(false, episode._action, episode._row);
            });
    },
    undoStartEpisode: function(event, data) {
        Hades.showLoading();
        $.fancybox.close(true);

        var params = {
            task_id:episode._row.task_id,
            reason_id:data.reasonId,
            other_reason:data.otherReason,
            date:data.date,
            hour:data.hour,
            wf_id:episode._row.wf_id,
            wf_status_id:data.wf_from_state_id,
            wf_action_id:data.wf_action_id};

        $.post('/episode/undo_start_episode', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    episode._callback(false, episode._action, episode._row);
                } else {
                    episode._callback(true, episode._action, episode._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                episode._callback(false, episode._action, episode._row);
            });
    },
    undoFinalizeEpisode: function(event, data) {
        Hades.showLoading();
        $.fancybox.close(true);

        var params = {};
        if (!episode._action.modal_params){
            var params = {
                task_id:episode._row.task_id,
                reason_id:data.reasonId,
                other_reason:data.otherReason,
                date:data.date,
                hour:data.hour,
                wf_id:episode._row.wf_id,
                wf_status_id:data.wf_from_state_id,
                wf_action_id: data.wf_action_id};
        }else{
            params = episode._action.modal_params;
        }

        episode._action.modal_params = params;

        if ((parseInt(episode._row.appointment_type_id) == globalConstants.APPOINTMENT_TYPE_EXAM && parseInt(episode._row.treatment_type_id) == globalConstants.TREATMENT_TYPE_MCDT)){
            processNS.reopenProccess(episode.undoEpisode, params);
        }else{
            episode.undoEpisode();
        }


    },
    undoEpisode: function(){
        var params = episode._action.modal_params;

        $.post('/episode/undo_finalize_episode', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    episode._callback(false, episode._action, episode._row);
                } else {
                    episode._callback(true, episode._action, episode._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                episode._callback(false, episode._action, episode._row);
            });
    },
    administrativeActions: function(event, data) {
        $.fancybox.close(true);
        var params = {
            task_id:episode._row.task_id,
            reason_id:data.reasonId,
            other_reason:data.otherReason,
            date:data.date,
            hour:data.hour,
            wf_id:episode._row.wf_id,
            wf_status_id:data.wf_status_id,
            wf_action_id:data.wf_action_id};

        $.post('/episode/administrative_actions', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    episode._callback(false, episode._action, episode._row);
                } else {
                    episode._callback(true, episode._action, episode._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                episode._callback(false, episode._action, episode._row);
            });
    },
    // Execute Generic Action
    executeGenericAction:function () {
        workflow.executeAction(episode._action, episode._callback, episode._row);
    },
    openScheduler:function(){
        var params = {
            task_id:episode._action.task_id,
            wf_id:episode._action.wf_id,
            wf_status_id:episode._action.to_state_id,
            wf_action_id:episode._action.wf_action_id,
            wf_from_state_id: episode._action.from_state_id
        };

        params.width = $(window).width();
        params.can_change_appointment_type = "0";
        params.can_change_specialty = "0";
        params.can_change_professional = "0";
        params.can_change_financial_institution = "0";
        params.show_week_button = false;

        debug.log("openScheduler", params);

        $.get('/calendar/calendar_pick_date', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data});

                $('#calendar-pick-date-ct').bind('dateSelected', episode.onSchedulerCloseHandler);
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });
    },
    onSchedulerCloseHandler:function(event, data) {
        $.fancybox.close(true);

        var params = {}
        params.professional_id = data.resource_id;
        params.professional_name = data.resource_desc;
        params.prev_date = data.prev_date;
        params.prev_hour = data.prev_hour;
        params.date = data.date;
        params.hour = data.hour;
        params.prev_professional_name = data.prev_professional_name;
        params.specialty_id = data.specialty_id;
        params.task_id = episode._action.task_id;
        params.wf_id = episode._action.wf_id;
        params.wf_status_id = episode._action.to_state_id;
        params.wf_action_id = episode._action.wf_action_id;
        params.appointment_duration = data.appointment_duration;

        $.get('/physiotherapy/confirm_session_reschedule', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                $('#generic-reason-modal-ct').bind('genericReasonConfirmed', episode.rescheduleSession);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });
    },
    rescheduleSession: function(evt, data){
        $.fancybox.close(true);

        Hades.showLoading();

        var params = {};
        params.appointment_id = data.appointment_id;
        params.professional = data.professional_id;
        params.specialty = data.specialty_id;
        params.app_date = data.date;
        params.app_hour = data.hour;
        params.reason_id = data.reasonId;
        params.reason_desc = data.otherReason;
        params.appointment_duration = data.appointment_duration;

        $.post('/appointments/reschedule_appointment', params)
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success == false) {
                    bootbox.alert(data.error);
                    episode._callback(false, episode._action, episode._row);
                } else {
                    // Data integration
                    integrationsNS.integrate(globalConstants.APPOINTMENT_INTEGRATION, {id: params.appointment_id, isReschedule: true});
                    notificationNS.notification(params.appointment_id, globalConstants.EXTERNAL_NOTIFICATION_APPOINTMENT, {isReschedule: true});
                    episode._callback(true, episode._action, episode._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });
    },

    openFinalizedSmapConsult: function (action, wf_action_params) {

        var params = {task_id:action.task_id,
            wf_id:action.wf_id,
            wf_status_id:action.to_state_id,
            wf_action_id:action.wf_action_id};

        $.get('/modal/smap_finalized_consult_modal', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                $('#smap-finalized-consult-modal-ct').bind('SmapFinalizedConsultModalConfirmed', this.wfWorkflowParamsCallback);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });

    },

    FinalizeSmapConsult: function (event, data) {
        $.fancybox.close(true);

        var params = {
            task_id: data.taskId,
            reason_id:data.reasonId,
            other_reason:data.otherReason,
            wf_id: data.wf_id,
            wf_action_id: data.wf_action_id,
            wf_status_id: data.wf_status_id};

        $.post('/episode/save_episode_discharge', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data != 1) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    episode._callback(false, episode._action, episode._row);
                } else {
                    episode._callback(true, episode._action, episode._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                episode._callback(false, episode._action, episode._row);
            });



    },

    undoFinalizeEpisodeHandler: function () {

        episode.openReason(episode.undoFinalizeEpisode);

    },
    undoFinalizeEpisodeProcessHandler: function (evt, data) {
        var params = {
            task_id: episode._row.task_id,
            reason_id: data.reasonId,
            other_reason: data.otherReason,
            date: data.date,
            hour: data.hour,
            wf_id: episode._row.wf_id,
            wf_status_id: episode._row.wf_status_id
        };

        episode._action.modal_params = params;

        episode.undoFinalizeEpisode();
    },

    finalizedEpisodeReasonModalHandler: function (event, data) {

            var params = {
                task_id: episode._row.task_id,
                reason_id: data.reasonId,
                other_reason: data.otherReason,
                date: data.date,
                hour: data.hour,
                wf_id: episode._row.wf_id,
                wf_status_id: episode._row.wf_status_id,
                wf_action_id: data.actionId
            };

            processNS.execute(episode._action, episode._row, episode.executeGenericAction, params);
        },
    checkCanUndoFinalizeEpisode: function(){
        var params = episode._action;

        processNS.execute(episode._action, episode._row, episode.undoFinalizeEpisodeProcess, params);

    },
    undoFinalizeEpisodeProcess: function(){
        episode.openReason(episode.undoFinalizeEpisodeProcessHandler);
    },
    checkPreviewsFinalized: function (){
        var params = {
            wf_id: episode._action.wf_id,
            task_id: episode._action.task_id
        };

        $.getJSON('/workflow/check_previous_finalized', params)
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (!data.finalized_count || data.finalized_count == 0) {

                    var params = {
                        task_id: episode._action.task_id,
                        wf_id: episode._action.wf_id,
                        wf_status_id: episode._action.wf_status_id,
                        wf_action_id: episode._action.wf_action_id,
                        reason_id: null,
                        other_reason: null,
                        date: null,
                        hour: null
                    };

                    processNS.execute(episode._action, episode._row, episode.executeGenericAction, params);
                }
                else {
                    episode.openReason(episode.finalizedEpisodeReasonModalHandler);
                }

            })
            .fail(function (xhr, status, error) {
                Hades.showError();
                Hades.hideLoading();
            });

    },

    get_episode_info: function (id, callback) {

        $.getJSON('/episode/get_episode_info', {id: id}, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);
                if (callback){
                    callback(data);
                }
            })
            .fail(function (xhr, status, error) {
            });


    }


};